import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "./hooks/useLenis";
import { EnquiryProvider } from "./enquiryContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyCTA from "./components/StickyCTA";
import EnquiryPopup from "./components/EnquiryPopup";
import Home from "./pages/Home";
import ProjectPage from "./pages/ProjectPage";
import { ONE_WORLD, NEOPOLIS } from "./content";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  useLenis();
  return (
    <div className="App grain">
      <Toaster position="top-center" richColors />
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sobha-one-world" element={<ProjectPage project={ONE_WORLD} other={NEOPOLIS} />} />
        <Route path="/sobha-neopolis" element={<ProjectPage project={NEOPOLIS} other={ONE_WORLD} />} />
      </Routes>
      <Footer />
      <StickyCTA />
      <EnquiryPopup />
    </div>
  );
}

export default function App() {
  return (
    <EnquiryProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </EnquiryProvider>
  );
}
